module.exports = __webpack_public_path__ + "img/itemImg.02096be8.png";